import * as dc from 'dc'
export class ChartInfo
{
    constructor(vizunit, first, flag, data)
    {
        this.data = data
        this.position = vizunit
        this.title = first["screenTitle"]
        this.width = first["width"] || 250
        this.height = first["height"] || 350
        this.menu = first["metricDisplayName"] || ""
        this.name = first["menuName"] || ""
        this.flag = first["visibleFlag"]
        this.x = first["y1_axisDisplayName"] || ""
        this.y = first["x1_axisDisplayName"] || ""
        this.div = first["metricDivisor"] || ""
        this.unit = first["metricUnit"] || ""
        this.group = first["metric1_dataFieldName"] || ""
        this.dim = first["dim1_dataFieldName"] || ""
        this.group2 = first["metric2_dataFieldName"] || ""
        this.dim2 = first["dim2_dataFieldName"] || ""
        this.y1color = first["y1_colorRange"] || ""
        this.y1_color_library = first["y1_color_library"] || ""
       // this.position = position//first["positionLogical"]

        this.chartElem = null;
        this.resetChart = () => {
            this.chartElem.filterAll()
            dc.redrawAll()
        }
    }


}
export class DcChartInfo
{
    constructor(vizunit, first, flag, data,margin)
    {
        this.data = data
        this.position = vizunit
        this.title = first["screenTitle"]
        this.width = first["chartWidth"] || 250
        this.height = first["chartHeight"] || 350
        this.margin = margin
        this.menu = first["metricDisplayName"] || ""
        this.name = first["screenTitleDpName"] || ""
        this.flag = first["visibleFlag"]
        this.x = first["y1_axisDisplayName"] || ""
        this.y = first["x1_axisDisplayName"] || ""
        this.div = first["y1_metricDivisor"] || ""
        this.unit = first["y1_metricUnit"] || ""
        this.group = first["y1_dataFieldName"] || ""
        this.dim = first["x1_dataFieldName"] || ""
        this.group2 = first["y2_dataFieldName"] || ""
        this.dim2 = first["x2_dataFieldName"] || ""
        this.y1color = first["y1_colorRange"] || ""
        this.y1_color_library = first["y1_color_library"] || ""
        this.columnHeader = first["reportHeaderColumnDp"] || ""

        this.chartElem = null;
        this.resetChart = () => {
            this.chartElem.filterAll()
            dc.redrawAll()
        }
    }


}
export class VizChartInfo {
    constructor(vizunit, margin, first, flag, data) {
        this.data = data
        this.position = vizunit
        this.title = first["title"]
        this.query = first["dataSource"]
        this.width = first["width"]
        this.height = first["height"]
        this.margin = margin
        this.menu = first["metricDisplayName"] || ""
        this.vizName = first["vizname"] || ""
        this.name = first["screenName"] || ""
        this.flag = flag
        this.measureFieldName = first["measureFieldName"] || ""
        this.x1AxisDisplayName = first["x1_axisDisplayName"] || ""
        this.x2AxisDisplayName = first["x2_axisDisplayName"] || ""
        this.y1AxisDisplayName = first["y1_axisDisplayName"] || ""
        this.y2AxisDisplayName = first["y2_axisDisplayName"] || ""

        this.div = first["metricDivisor"] || ""
        this.unit = first["metricUnit"] || ""
        //todo, a calculation sometime
        this.group = first["metric1_dataFieldName"] || ""
        this.dim = first["dim1_dataFieldName"] || ""
        this.group2 = first["metric2_dataFieldName"] || ""
        this.dim2 = first["dim2_dataFieldName"] || ""
        this.y1colorRange = first["y1_colorRange"] || ""
        this.y2colorRange = first["y2_colorRange"] || ""
        this.y1colorLibrary = first["y1_color_library"] || ""
        this.y2colorLibrary = first["y2_color_library"] || ""
        this.vizTitle = first["vizTitle"]
        this.vizType = first["vizType"]
        this.vizSpecific1 = first["vizSpecific1"]
        this.vizSpecific2 = first["vizSpecific2"]
        this.vizSpecific3 = first["vizSpecific3"]
        this.vizSpecific4 = first["vizSpecific4"]
        this.vizSpecific5 = first["vizSpecific5"]
        this.titleToolTip = first["titleToolTip"]
        this.x1DataFieldName = first['x1_dataFieldName']
        this.x2DataFieldName = first['x2_dataFieldName']
        this.y1DataFieldName = first['y1_dataFieldName']
        this.y2DataFieldName = first['y2_dataFieldName']
        this.y1MetricTooltip = first['y1_metricTooltip']
        this.y2MetricTooltip = first['y2_metricToolTip']
        this.titleToolTip = first['titleToolTip']

    }
}

    export class FwVizChartInfo {
    constructor(vizunit, margin, first, flag, data) {
        this.data = data
        this.position
        //this.title = first["screenTitle"]
        this.title = first["screenTitleDpName"]
        //this.query = first["datasqlQuery"]
        this.query = first["datasql"]
        this.width = first["chartWidth"]
        this.height = first["chartHeight"]
        this.margin = margin
        this.axisFontSize = first["axisFontSize"]
        this.axisFontColor = first["axisFontColor"]
        this.axisLabelDistance = first["axisLabelDistance"]
        this.axisLabelFontSize = first["axisLabelFontSize"]
        this.axisLabelFontColor = first["axisLabelFontColor"]
        this.topLabelLength = first["topLabelLength"]
        this.bottomLabelLength = first["bottomLabelLength"]
        this.leftLabelLength = first["leftLabelLength"]
        this.rightLabelLength = first["rightLabelLength"]
        this.menu = first["metricDisplayName"] || ""
        this.vizName = first["viztypeName"] || ""
        this.name = first["screenName"] || ""
        this.flag = first["visibleFlag"]
        this.measureFieldName = first["measureFieldName"] || ""
        this.x1AxisDisplayName = first["x1_axisDisplayName"] || ""
        this.x2AxisDisplayName = first["x2_axisDisplayName"] || ""
        this.y1AxisDisplayName = first["y1_axisDisplayName"] || ""
        this.y2AxisDisplayName = first["y2_axisDisplayName"] || ""
        this.div = first["metricDivisor"] || ""
        this.unit = first["metricUnit"] || ""
        //todo, a calculation sometime
        this.group = first["metric1_dataFieldName"] || ""
        this.dim = first["dim1_dataFieldName"] || ""
        this.group2 = first["metric2_dataFieldName"] || ""
        this.dim2 = first["dim2_dataFieldName"] || ""
        this.y1colorRange = first["y1_colorRange"] || ""
        this.y2colorRange = first["y2_colorRange"] || ""
        this.y1colorLibrary = first["y1_color_library"] || ""
        this.y2colorLibrary = first["y2_color_library"] || ""
//        this.vizTitle = first["vizTitle"]
        this.vizTitle = first["vizletTitleDpName"]
        this.vizType = first["viztypeName"]
        this.vizSpecific1 = first["vizSpecific1"]
        this.vizSpecific2 = first["vizSpecific2"]
        this.vizSpecific3 = first["vizSpecific3"]
        this.vizSpecific4 = first["vizSpecific4"]
        this.vizSpecific5 = first["vizSpecific5"]
        this.titleToolTip = first["titleTooltip"]
        this.x1DataFieldName = first['x1_dataFieldName']
        this.x2DataFieldName = first['x2_dataFieldName']
        this.y1DataFieldName = first['y1_dataFieldName']
        this.y2DataFieldName = first['y2_dataFieldName']
        this.x1MetricTooltip = first['x1_metricTooltip']
        this.x2MetricTooltip = first['x2_metricTooltip']
        this.y1MetricTooltip = first['y1_metricTooltip']
        this.y2MetricTooltip = first['y2_metricTooltip']
        this.legendMetricTooltip = first['legend_metric_tooltip']
        this.titleToolTip = first['titleToolTip']
        this.reportHeaderColumnDp = first['reportHeaderColumnDp']
        this.highLowBetter = first['highLowBetter']
        this.jsonFile = first['jsonFile']
        this.colourscheme1 = first['colourscheme1']
        this.x1MetricUnit = first['x1_metricUnit']
        this.vizSpecific6 = first['viz_specific6']
        this.x1D3ScaleType = first['x1_d3scaleType']
        this.x2D3ScaleType = first['x2_d3scaleType']
        this.y1D3ScaleType = first['y1_d3scaleType']
        this.y2D3ScaleType = first['y2_d3scaleType']
        this.x1AxisLabelCharLimitsJson = first['x1_axis_label_char_limits_json']
        this.reportHeaderColumnDpWordwrap = first['report_header_column_dp_wordwrap']
        this.vizletTitleInfo = first['vizlet_title_info']
        this.tabReportJson = first['tab_report_json']
        this.numberSystem = first['number_system']
        this.numberDisplayType = first['number_display_type']
        this.insightNavigator = first['insight_navigator']
        this.vizSpecific7 = first['viz_specific7']
        this.vizParamJson = first['viz_param_json']
    }
}